import React from 'react'
import Header from './components/Header'
import Copywrite from './components/copywrite'
import Footer from '../../components/Footer'
import DataWrapper from './components/DataWrapper'
import { refundSteps, returnNote } from './constant/data'

const ReturnPage = () => {
    return (
        <div>
            <Header Title="Refund & Returns Policy" lastUpdated="Last Updated on January 1st, 2025" />
            <div className='md:p-12 p-6 max-w-7xl mx-auto'>
                <DataWrapper heading="">
                    <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                        You have 6 months or 180 days after we ship your order to enjoy your product and give it enough time to benefit you. Like many of our satisfied customers, we hope you’ll benefit from it immensely and happily reorder more each time you run out.
                    </p>
                    <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                        We recommend you enjoy your product for as long as you can before you contact us asking for a refund. You’re perfectly entitled to make the most of your ample guarantee period and we encourage you to. However, if you’re not satisfied with what you see and feel, it’s easy to get in touch with us to request a refund.</p>
                    <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                        Make sure to follow the simple 3-step process below in order to be refunded for your order.
                    </p>

                    <ul>
                        {refundSteps.map((step, index) => (
                            <li key={index} className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">{index + 1}. {step}</li>
                        ))}
                    </ul>
                    <ul style={{ listStyleType: "disc" }} className='ml-8'>
                        {returnNote.map((item, index) => (
                            <li key={index} className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">{item}</li>
                        ))}
                    </ul>
                    <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                        Returns address: <span className='font-bold'>
                            285 Northeast Ave, Tallmadge, OH 44278, United States.
                        </span>
                    </p>
                    <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                        Make sure to contact us and receive confirmation from an agent before you return your order otherwise this could result in your return being impossible to locate and may delay your refund.
                    </p>
                    <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                        Once we receive your returned order and register it, you’ll be refunded in full. You’ll receive email confirmation of this when your refund is initiated. It will usually take 5-10 days to appear on your statement.

                    </p>
                </DataWrapper>

                <DataWrapper heading="HOW TO CONTACT US">
                    <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                        Product Email Support:  <a
                            href="mailto:support@herbalteatherapy.com"
                            className="text-blue-600 hover:text-blue-800 underline"
                        >
                            support@herbalteatherapy.com
                        </a>
                    </p>
                    <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                        Customer Support Number:{" "}
                        <a
                            href="tel:+13305213590"
                            className="text-blue-600 hover:text-blue-800 underline"
                        >
                            +1 (330) 521-3590
                        </a>
                    </p>


                </DataWrapper>
                <div className='flex items-center justify-center w-full'>
                    <Copywrite />
                </div>
            </div>
        </div>
    )
}

export default ReturnPage
